import { Component }             from '@angular/core';
import { NavController }         from 'ionic-angular';
import { AlertController }       from 'ionic-angular';
import { LoadingController }     from 'ionic-angular';
import { dmHotel }               from '../sign-in/xv-hotel';
import { AppMenuViewModel }      from '../../app/xv-menu';
import { PMSViewModel }          from './xv-pms';
import { MLText, mlBroker }      from '../../services/MLText';
import { AppDataBroker }         from '../../services/AppData';
import { SignInPage }            from '../sign-in/sign-in';
import { dmLoading }             from '../loading/loading';

@Component({
   selector:    'page-pms'
  ,templateUrl: 'pms.html'
})
export class PMSPage {
    PMS:          PMSViewModel;
    ShowAlert:    (pTitle: string, pMessage: string) => void;
    NewLoading:   (pMessage: string)                 => dmLoading;
    ReloadMenu:   ()                                 => void;
    BackToSignIn: ()                                 => void;

    app: mlBroker;

    constructor(
         public navCtrl:       NavController
        ,public alertCtrl:     AlertController
        ,public loadingCtrl:   LoadingController
        ,public mlText:        MLText
        ,public appDataBroker: AppDataBroker
    ) {
        let hotel = appDataBroker.GetAppData()          as dmHotel;
        let menu  = appDataBroker.GetAppMenuViewModel() as AppMenuViewModel;

        this.app  = this.mlText.GetBroker(
            'BookingEngineAppTexts'
        );

        this.ShowAlert = (pTitle: string, pMessage: string) => {
            let alert = this.alertCtrl.create({
                 title:   pTitle
                ,message: pMessage
                ,buttons: [
                    {
                         text:    this.app.Text('OK')
                        ,handler: () => { return true; }
                    }
                ]
            });

            alert.present();
        };

        this.NewLoading = (pMessage: string) => {
            let loadingWidget = loadingCtrl.create({
                 content: pMessage
            });

            let loadingAPI = new dmLoading(
                (pAction: () => void) => {
                    loadingWidget.present().then(() => { pAction(); })
                }
                ,() => {
                    if (!loadingAPI.IsDismissed) {
                        loadingWidget.dismiss();
                    }
                }
            );

            loadingWidget.onDidDismiss(() => {
                loadingAPI.IsDismissed = true;
            });

            return loadingAPI;
        };

        this.ReloadMenu = () => {
            menu.InitializeMenu();

            menu.Menu.NavToPMS();
        };

        this.BackToSignIn = () => {
            this.navCtrl.setRoot(SignInPage);
        };

        this.PMS = new PMSViewModel(
             mlText
            ,hotel
            ,this.BackToSignIn
            ,this.ReloadMenu
            ,this.ShowAlert
            ,this.NewLoading
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/pms/pms.ts